/* import __COLOCATED_TEMPLATE__ from './marketing-confirm-coupon-cancellation-body.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();